module.exports = __webpack_public_path__ + "static/media/21.5687c32b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/21.jpg
// module id = 182
// module chunks = 0